"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ledgerHandler = void 0;
var hw_app_str_1 = __importDefault(require("@ledgerhq/hw-app-str"));
var hw_transport_u2f_1 = __importDefault(require("@ledgerhq/hw-transport-u2f"));
var stellar_sdk_1 = require("@stellar/stellar-sdk");
var Types_1 = require("../Types");
exports.ledgerHandler = {
    keyType: Types_1.KeyType.ledger,
    signTransaction: function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, key, transport, ledgerApi, signatureBase, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        transaction = params.transaction, key = params.key;
                        if (key.privateKey !== "") {
                            throw new Error("Non-ledger key sent to ledger handler: ".concat(JSON.stringify(key.publicKey)));
                        }
                        return [4 /*yield*/, hw_transport_u2f_1.default.create(60 * 1000)];
                    case 1:
                        transport = _a.sent();
                        ledgerApi = new hw_app_str_1.default(transport);
                        signatureBase = Buffer.from(transaction.signatureBase());
                        return [4 /*yield*/, ledgerApi.signTransaction(key.path, signatureBase)];
                    case 2:
                        result = _a.sent();
                        // Pass the signature across as base64 rather than constructing an
                        // xdr.DecoratedSignature here: this package bundles its own stellar-sdk
                        // copy, and a wrapper class built by it is rejected by the consumer's copy.
                        // See the note in Handlers/plaintextKey.ts.
                        transaction.addSignature(key.publicKey, stellar_sdk_1.xdr.encodeBytes(result.signature, "base64"));
                        return [2 /*return*/, Promise.resolve(transaction)];
                }
            });
        });
    },
};
